"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetailCustomer = void 0;
const class_validator_1 = require("class-validator");
const User_1 = require("../../../../apis/spg/models/User");
/**
 * A user that can purchase goods different retail locations of which they
 * can pick up or have delivered to their desired address. They can also
 * nominate to receive order notifications and marketing material as well as
 * participate in loyalty programs.
 */
class RetailCustomer extends User_1.User {
    constructor() {
        super(...arguments);
        this.receiveNotifications = true;
        this.receiveMarketing = false;
    }
    get firstName() {
        const splitName = this.name.split(" ");
        return splitName[0];
    }
    get lastName() {
        const splitName = this.name.split(" ");
        if (splitName.length === 1) {
            // only first name given
            return "";
        }
        splitName.shift(); // remove first name
        return splitName.join(" "); // join any remaining names
    }
    get isRetailCustomerBlocked() {
        return this.active === false || this.suspend === true;
    }
    /**
     * Transforms retail customer data such that it can be consumed by a comms
     * template
     */
    get commsData() {
        return Object.assign(Object.assign({}, this.serialize()), { address: (() => {
                if (!this.address) {
                    return "";
                }
                const { fullAddress } = this.address;
                return fullAddress;
            })() });
    }
    serialize() {
        return Object.assign(Object.assign({}, super.serialize()), { retailCustomerId: this.retailCustomerId, name: this.name, mobileNumber: this.mobileNumber, birthDate: this.birthDate, address: this.address, receiveNotifications: this.receiveNotifications, receiveMarketing: this.receiveMarketing, paydockCustomerId: this.paydockCustomerId, defaultNotes: this.defaultNotes, verificationCode: this.verificationCode, verificationCodeExpiry: this.verificationCodeExpiry });
    }
    static unserialize(data) {
        const newCustomer = super.unserialize(data);
        newCustomer.retailCustomerId = data.retailCustomerId;
        newCustomer.name = data.name;
        newCustomer.mobileNumber = data.mobileNumber;
        newCustomer.birthDate = data.birthDate;
        newCustomer.address = data.address;
        newCustomer.receiveNotifications = data.receiveNotifications;
        newCustomer.receiveMarketing = data.receiveMarketing;
        newCustomer.paydockCustomerId = data.paydockCustomerId;
        newCustomer.defaultNotes = data.defaultNotes;
        newCustomer.verificationCode = data.verificationCode;
        newCustomer.verificationCodeExpiry = data.verificationCodeExpiry;
        return newCustomer;
    }
    filterSensitiveData() {
        const clone = super.filterSensitiveData();
        delete clone.verificationCode;
        delete clone.verificationCodeExpiry;
        return clone;
    }
}
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)()
], RetailCustomer.prototype, "retailCustomerId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)()
], RetailCustomer.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)()
], RetailCustomer.prototype, "mobileNumber", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)()
], RetailCustomer.prototype, "birthDate", void 0);
__decorate([
    (0, class_validator_1.IsOptional)()
], RetailCustomer.prototype, "address", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)()
], RetailCustomer.prototype, "receiveNotifications", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)()
], RetailCustomer.prototype, "receiveMarketing", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)()
], RetailCustomer.prototype, "paydockCustomerId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)()
], RetailCustomer.prototype, "defaultNotes", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsPositive)(),
    (0, class_validator_1.IsOptional)()
], RetailCustomer.prototype, "verificationCode", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsPositive)(),
    (0, class_validator_1.IsOptional)()
], RetailCustomer.prototype, "verificationCodeExpiry", void 0);
exports.RetailCustomer = RetailCustomer;
//# sourceMappingURL=RetailCustomer.js.map